// extracted by mini-css-extract-plugin
export default {"virtualTourStatus":"VirtualTourStatusIndicator_virtualTourStatus__P3LaT","green":"VirtualTourStatusIndicator_green__3HgTg","red":"VirtualTourStatusIndicator_red__tXZQ1"};